"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preventWhiteSpace = exports.isValidPhoneNumber = exports.isValidSyngentaEmail = exports.isValidEmail = exports.isFormattedPhoneNumber = void 0;

var isFormattedPhoneNumber = function isFormattedPhoneNumber(string) {
  return string.match(/[()-]/g) && string.match(/[()-]/g).length && string.match(/[()-]/g).length === 3 && string.length === 16;
};

exports.isFormattedPhoneNumber = isFormattedPhoneNumber;

var isValidEmail = function isValidEmail(input) {
  return typeof input === 'string' && input.includes('@');
};

exports.isValidEmail = isValidEmail;

var isValidSyngentaEmail = function isValidSyngentaEmail(input) {
  if (typeof input === 'string') {
    var lowerCase = input.toLowerCase();
    return lowerCase.includes('@syngenta.com');
  }

  return false;
};

exports.isValidSyngentaEmail = isValidSyngentaEmail;

var isValidPhoneNumber = function isValidPhoneNumber(string) {
  var regex = /^[0-9( )-]*$/;
  var result = regex.test(string) && string.length === 10;
  return result;
};

exports.isValidPhoneNumber = isValidPhoneNumber;

var preventWhiteSpace = function preventWhiteSpace(e) {
  var key = e.keyCode;

  if (key === 32) {
    e.preventDefault();
  }
};

exports.preventWhiteSpace = preventWhiteSpace;